import { makeStyles } from '@material-ui/styles';

import { BoundModal } from '@bizzabo/design-system';
import { UserPreview } from '@bizzabo/entities';

import { ScheduledMeeting } from '../../types';
import AddToCalendar from '../AddToCalendar';

type Props = {
    meeting: ScheduledMeeting;
    otherUser: UserPreview;
    isOpen: boolean;
    closeModal: () => void;
};

const AddToCalendarModal: React.FC<Props> = ({ isOpen, closeModal, meeting, otherUser }) => {
    const classes = useStyles();

    return (
        <BoundModal
            className={classes.modal}
            style={{ position: 'absolute' }}
            BackdropProps={{ style: { position: 'absolute' } }}
            open={isOpen}
            onClose={closeModal}
        >
            <div className={classes.content}>
                <AddToCalendar meeting={meeting} otherUser={otherUser} onClose={closeModal} />
            </div>
        </BoundModal>
    );
};

const useStyles = makeStyles(
    () => ({
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        content: {
            maxWidth: 500,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative',
            padding: '40px 40px 20px',
            margin: '0 30px',
            borderRadius: 16,
            outline: 'none',
        },
    }),
    { classNamePrefix: 'add-to-calendar' }
);

export default AddToCalendarModal;
